/**
 * ProductFruits Utility Functions
 * Shared utilities used across ProductFruits modules
 */

/**
 * Serializes an error object into a safe, serializable format
 * Handles Error instances, strings, null, undefined, and other types
 */
export function serializeError(error) {
  // Handle null/undefined
  if (error === null || error === undefined) {
    return {
      message: 'Unknown error',
      details: 'Error was null or undefined',
    };
  }

  // Handle Error instances
  if (error instanceof Error) {
    return {
      message: error.message || 'Unknown error',
      stack: error.stack,
      name: error.name,
    };
  }

  // Handle string errors
  if (typeof error === 'string') {
    return { message: error };
  }

  // Handle other types
  try {
    return {
      message: 'Unknown ProductFruits error',
      details: String(error),
    };
  } catch {
    // Fallback if String() conversion fails
    return {
      message: 'Unknown ProductFruits error',
      details: 'Unable to serialize error',
    };
  }
}

